var es = {
    translation: {
        button: {
            back: 'Atrás',
            backToAccountServices: 'REGRESAR A SERVICIOS DE CUENTA',
            cancel: 'CANCELAR',
            changeDueDate: 'Cambiar Fecha de Vencimiento',
            close: 'CERRAR',
            creditLimitIncrease: 'Aumento del Límite de Crédito',
            requestIncrease: 'SOLICITAR AUMENTO',
            submit: 'Enviar'
        },
        changePaymentDueDate: {
            changePaymentDueDate: 'Cambiar fecha de vencimiento de pago',
            modalHeader: 'Cambiar Fecha de Vencimiento'
        },
        cliBusinessError: {
            subTitle: 'Recibirá una carta dentro de 7 a 10 días hábiles en la que se le explicará la razón de nuestra decisión.',
            title: 'No podemos aumentar su límite de crédito en este momento'
        },
        cliPartialSuccess: {
            subTitle: 'No podemos otorgarle el monto total que ha solicitado. Sin embargo, podemos aumentar su límite de crédito. Recibirá una carta dentro de 7 a 10 días hábiles en la que se le explicará la razón de nuestra decisión.'
        },
        cliPendingReferral: {
            subTitle: 'Estamos revisando su solicitud. Recibirá una carta dentro de 7 a 10 días hábiles con nuestra decisión sobre su solicitud.',
            title: 'Su solicitud de límite de crédito está pendiente.'
        },
        cliSuccess: {
            newLimit: 'NUEVO LÍMITE DE CRÉDITO',
            subText: 'Su límite de crédito está disponible para uso inmediato.',
            subTitle: 'Su solicitud de aumento del límite de crédito se aprobó por lo siguiente:',
            title: 'Hemos aumentado su límite de crédito'
        },
        errorMessages: {
            accessDeniedMessageBox: {
                body: 'Por favor llame al (800) 508-2520 para obtener ayuda. Siempre estamos disponibles para ayudar; llámenos las 24 horas, los 7 días de la semana.',
                title: 'Estamos teniendo problemas para verificar su identidad'
            },
            addPrimaryHolder: {
                extraInfo: 'Intente nuevamente con otro nombre.',
                subTitle: 'Usted ingresó un nombre de Titular de Tarjeta que ya tiene una tarjeta.',
                title: 'Por favor, vuelva a intentarlo'
            },
            addressChanged: 'No podemos tramitar su solicitud porque su dirección ha cambiado en los últimos 30 días.',
            dueDateChangePeriodRestriction: {
                subTitle: 'Puede cambiar su fecha de vencimiento una vez cada 12 meses.',
                title: 'Usted no puede cambiar su fecha de vencimiento ahora mismo'
            },
            nameChanged: 'No podemos tramitar su solicitud porque ha cambiado su nombre en los últimos 30 días.',
            notEligible: {
                body: 'En este momento no podemos procesar su solicitud de Cambiar la Fecha de Vencimiento.',
                title: 'Su cuenta no es elegible'
            },
            notEligibleAccount: 'Su cuenta no es elegible',
            profanity: {
                title: 'Por favor, vuelva a intentarlo',
                unapprovedName: 'El nombre o nombres que nos ha proporcionado no pudieron ser aceptados tal como fueron ingresados. Por favor, realice las correcciones necesarias y vuelva a intentarlo.'
            },
            troubleAccessingAccount: 'Tenemos problemas para acceder a su cuenta',
            troubleRetrievingInformation: 'Tenemos problemas para recuperar su información',
            tryAgainLater: 'Por favor, vuelva a intentarlo más tarde.',
            unableToProcessRequest: 'Lamentablemente no podemos procesar su solicitud en este momento. Por favor intente nuevamente más tarde.'
        },
        mocks: {
            accountEnding: 'Cuenta que termina en {{accountLast4}}',
            availableToSpend: 'Disponible para gastar',
            beginLogin: 'Iniciar sesión',
            cardAccountEnding: 'Tarjeta para cuenta que termina en {{accountLast4}}',
            clientId: 'Ingrese una identificación de cliente',
            currentBalance: 'Saldo Actual',
            environment: 'Elige un entorno',
            logout: 'cerrar sesión',
            makeAPayment: 'Realizar un pago',
            paymentDueDate: 'Fecha de vencimiento del pago',
            totalMinimumPayment: 'Pago Mínimo Total'
        },
        modal: {
            annualNetIncome: 'Ingresos Netos Anuales',
            annualNetIncomeHelperText: 'Incluya ingresos de fuentes después de impuestos',
            annualNetIncomeInputErrorText: 'Ingrese el monto de sus ingresos, incluyendo fuentes después de impuestos',
            cliRequest: 'Solicitar un aumento del límite de crédito',
            closeDialog: 'Cerrar diálogo',
            creditLimit: "{{creditLimit}}",
            currentCreditLimit: 'LÍMITE DE CRÉDITO ACTUAL',
            desiredIncreaseInputErrorText: 'Ingrese el límite de crédito que desea solicitar',
            desiredLimit: 'Límite Deseado',
            desiredLimitHelperText: 'Ingrese el límite de crédito total que desea solicitar',
            header: 'Aumento del Límite de Crédito',
            increaseLimitByMore: 'El nuevo límite deseado debe ser al menos de $50 más que el límite de crédito actual',
            maxCreditLimit: 'Usted no puede solicitar un límite de crédito mayor que $99,999.00',
            tooltipLabelButton: '¿Cómo afecta mi calificación crediticia?',
            tooltipMessage: 'No obtendremos un informe de agencia de informes crediticios para evaluar su solicitud y recibirá una decisión instantáneamente.'
        },
        text: {
            accountActions: 'Acciones de cuenta',
            accountServices: 'Servicios de cuenta',
            address: 'Dirección',
            amount: 'Monto',
            autoPay: 'Pagos Automáticos',
            cardManagement: 'Administración de Tarjetas',
            enrollmentOpportunities: 'Oportunidades de inscripción',
            legalText: "Sus \u201CIngresos Netos\u201D incluyen lo que gana o lo que razonablemente espera ganar por su empleo,\n       inversiones, jubilaci\u00F3n, beneficios del seguro social y asistencia p\u00FAblica. Tambi\u00E9n puede incluir el dinero\n       que otra persona deposita regularmente en su cuenta (individual o conjunta) y el monto que tiene disponible\n       para gastar de sus activos. Si usted tiene 21 a\u00F1os o m\u00E1s, tambi\u00E9n podr\u00E1 incluir el monto de los ingresos de\n       alguna otra persona que se use peri\u00F3dicamente para pagar sus gastos. No es necesario incluir la cuota alimentaria,\n       la manutenci\u00F3n de menores ni los ingresos de manutenci\u00F3n por separaci\u00F3n judicial, salvo que se dependa de estos\n       para el cr\u00E9dito. Residentes de Wisconsin (WI) \u00DAnicamente: Si esta es una cuenta individual, por favor tambi\u00E9n\n       incluya los ingresos de su c\u00F3nyuge.",
            manageCardHolders: 'Administrar titulares de tarjetas',
            paymentSecurity: 'TODO'
        }
    }
};
export default es;
